import Card from '@/models/Card';

export default [
  new Card({
    id: 1,
    name: 'Artillery',
    imageName: 'blue-artillery',
    defaultQuantity: 0,
    possibleValues: [0, 1, 2],
  }),
  new Card({
    id: 2,
    name: 'Artillery',
    imageName: 'red-artillery',
    defaultQuantity: 0,
    possibleValues: [0, 1, 2],
  }),
  new Card({
    id: 3,
    name: 'Civilians',
    imageName: 'blue-civilians',
    defaultQuantity: 0,
    possibleValues: [0, 1, 2],
  }),
  new Card({
    id: 4,
    name: 'Civilians',
    imageName: 'red-civilians',
    defaultQuantity: 0,
    possibleValues: [0, 1, 2],
  }),
  new Card({
    id: 5,
    name: 'Forward Boys',
    imageName: 'blue-forward-boys',
    quantity: 1,
    noHoldBack: true,
  }),
  new Card({
    id: 6,
    name: 'Forward Boys',
    imageName: 'red-forward-boys',
    quantity: 1,
    noHoldBack: true,
  }),
  new Card({
    id: 7,
    name: 'Indians',
    imageName: 'blue-indians',
    defaultQuantity: 4,
    possibleValues: [0, 4],
  }),
  new Card({
    id: 8,
    name: 'Indians',
    imageName: 'red-indians',
    defaultQuantity: 4,
    possibleValues: [0, 4],
  }),
  new Card({
    id: 9,
    name: 'Irregulars',
    imageName: 'blue-irregulars',
    quantity: null,
    defaultQuantity: 4,
    possibleValues: [0, 4],
  }),
  new Card({
    id: 10,
    name: 'Irregulars',
    imageName: 'red-irregulars',
    quantity: null,
    defaultQuantity: 4,
    possibleValues: [0, 4],
  }),
  new Card({
    id: 11,
    name: 'Militia',
    imageName: 'blue-militia',
    quantity: null,
    defaultQuantity: 3,
    possibleValues: [0, 3],
  }),
  new Card({
    id: 12,
    name: 'Militia',
    imageName: 'red-militia',
    quantity: null,
    defaultQuantity: 3,
    possibleValues: [0, 3],
  }),
  new Card({
    id: 13,
    name: 'Morale',
    imageName: 'blue-morale',
    quantity: 1,
    noHoldBack: true,
  }),
  new Card({
    id: 14,
    name: 'Morale',
    imageName: 'red-morale',
    quantity: 1,
    noHoldBack: true,
  }),
  new Card({
    id: 15,
    name: 'Provincials',
    imageName: 'blue-provincials',
    possibleValues: [0, 3],
  }),
  new Card({
    id: 16,
    name: 'Provincials',
    imageName: 'red-provincials',
    possibleValues: [0, 3],
  }),
  new Card({
    id: 17,
    name: 'Regulars',
    imageName: 'blue-regulars',
    quantity: null,
    defaultQuantity: 4,
    possibleValues: [0, 4],
  }),
  new Card({
    id: 18,
    name: 'Regulars',
    imageName: 'red-regulars',
    quantity: null,
    defaultQuantity: 4,
    possibleValues: [0, 4],
  }),
  new Card({
    id: 19,
    name: null,
    imageName: 'clock-red',
    quantity: 1,
  }),
  new Card({
    id: 20,
    name: null,
    imageName: 'clock-green',
    quantity: 2,
  }),
];
